<template>
  <nav class="bg-blue-600 shadow-lg">
    <div class="container mx-auto px-4">
      <div class="flex justify-between items-center py-4">
        <div class="text-white font-bold text-xl">Patientenverwaltung</div>
        <div class="relative">
          <button @click="toggleManagement" 
                  class="text-white hover:bg-blue-700 px-3 py-2 rounded-md text-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-blue-600 focus:ring-white">
            Verwaltung
          </button>
          <ManagementDropdown v-if="showManagement" @close="showManagement = false" />
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { ref } from 'vue';
import ManagementDropdown from './ManagementDropdown.vue';

export default {
  name: 'NavbarMain',
  components: {
    ManagementDropdown
  },
  setup() {
    const showManagement = ref(false);

    const toggleManagement = () => {
      showManagement.value = !showManagement.value;
    };

    return {
      showManagement,
      toggleManagement
    };
  }
}
</script>